<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">Misc Request</h1>
      <router-link
        :to="`/request/misc/edit/${$route.params.id}`"
        class="button is-small is-primary is-uppercase"
      >Edit</router-link>
    </div>
    <div class="box">
      <table class="table is-fullwidth">
        <tr>
          <th>Employee ID</th>
          <td>{{ misc.employeeId }}</td>
        </tr>
        <tr>
          <th>Name</th>
          <td>{{ misc.name }}</td>
        </tr>
        <tr>
          <th>Mobile</th>
          <td>{{ misc.mobile }}</td>
        </tr>
        <tr>
          <th>Email</th>
          <td>{{ misc.email }}</td>
        </tr>
        <tr>
          <th>From</th>
          <td>{{ misc.startDate | date }}</td>
        </tr>
        <tr>
          <th>To</th>
          <td>{{ misc.endDate | date }}</td>
        </tr>
        <tr>
          <th>Reason</th>
          <td>{{ misc.reason }}</td>
        </tr>
      </table>

      <div class="is-flex">
        <div class="is-expanded">
          <router-link to="/request/misc" class="button is-borderless">Back</router-link>
        </div>
        <div class="is-expanded has-text-right"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      misc: {}
    };
  },
  mounted() {
    let component = this;
    component.$store
      .dispatch("misc/show", component.$route.params.id)
      .then(response => {
        component.misc = response.data;
      });
  }
};
</script>
